import { combineReducers } from "redux";
import fip from "./fipReducer";
import authenticationReducer from "./authenticationReducer";
import loader from "./loadingReducer";
import user from "./userReducer";

export default combineReducers({
  fip,
  authenticationReducer,
  loader,
  user,
});
